<template>
    <v-layout justify-center>
        <v-flex xs12>
            <v-form v-model="valid" ref="form" lazy-validation>

                <v-snackbar top v-model="success" color="success">
                    <span> <v-icon>check_circle</v-icon>  {{messages}} </span>
                </v-snackbar>

                <v-snackbar top v-model="error" color="error">
                    <span> <v-icon>info</v-icon>  {{messages}} </span>
                </v-snackbar>
                <v-container fluid grid-list-lg style="margin: 0;padding: 0">
                    <v-layout row wrap style="margin: 0;padding: 0">
                        <v-flex xl12 lg12 md4 sm12 xs12 style="margin: 0;padding: 0">
                            <v-btn dark small flat class="grey darken-1" @click.native="onUpload" :disabled="!valid"
                                   style="margin: 0;">
                                Selecionar arquivos
                                <v-icon right dark>cloud_upload</v-icon>
                            </v-btn>
                            <p style="font-size: 10px">Arquivos suportado MP3</p>
                        </v-flex>

                        <v-flex xl12 lg12 md12 sm12 xs12 v-if="doUpload">

                            {{filename}}

                            <v-btn class="right" icon @click="deleteFiles()" :disabled="!valid">
                                <v-icon class="red--text">delete</v-icon>
                            </v-btn>

                            <v-divider class="mt-5"></v-divider>
                        </v-flex>
                        <v-flex xl12 lg12 md12 sm12 xs12 v-if="loading">
                            <div id="progress"></div>
                            <div id="progress-text"></div>
                        </v-flex>
                        <v-flex xl12 class="text-xs-right">
                            <v-btn flat class="primary" :disabled="!valid" @click="submit"
                                   v-if="doUpload">Enviar arquivos
                            </v-btn>
                        </v-flex>
                        <input style="display: none" type="file" :multiple="true" ref="fileInput" accept="mp3"
                               @change="onFileChange">
                    </v-layout>
                </v-container>
            </v-form>
        </v-flex>
    </v-layout>
</template>
<style>
    #progress {
        display: block;
        height: 2px;
        background-color: #349936;
        width: 0;
    }
</style>
<script>
    export default {
        name: 'uploads',
        props: ['url', 'fields'],
        data: () => {
            return {
                valid: true,
                error: false,
                success: false,
                messages: '',
                doUpload: false,
                loading: false,
                accepts: '.mp4',
                filename: {},
                nameRules: [
                    (v) => !!v || 'O campo nome completo é obrigatório'
                ]
            }
        },
        methods: {
            deleteFiles: function () {
                this.filename = {}
            },
            onUpload() {
                if (!this.disabled) {
                    this.$refs.fileInput.click()
                }
            },
            bytesToSize: function (bytes) {
                var sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB']
                if (bytes === 0) return '0 Byte'
                var i = parseInt(Math.floor(Math.log(bytes) / Math.log(1024)))
                return Math.round(bytes / Math.pow(1024, i), 2) + ' ' + sizes[i]
            },
            onFileChange(e) {
                var self = this
                var files = e.target.files
                this.doUpload = true
                var ext = files[0].name.substring(files[0].name.lastIndexOf('.') + 1)
                if (ext === 'jpg' || ext === 'jpeg' || ext === 'png') {
                    var title = files[0].name.replace(/.\w+$/, '')
                    self.filename = {
                        file: files[0],
                        title: title,
                        ext: ext,
                        size: self.bytesToSize(files[0].size)
                    }
                } else {
                    self.error = true
                    self.messages = 'Arquivo não suportado!'
                }
            },
            submit() {
                let form = new FormData()
                var self = this
                self.success = false
                self.error = false
                self.messages = ''
                self.loading = true
                if (this.$refs.form.validate()) {
                    form.append('fields', JSON.stringify(self.fields))
                    form.append('media', self.filename.file, self.filename.title + '.' + self.filename.ext)
                    self.axios.post(this.url, form, {
                        onUploadProgress: uploadEvent => {
                            this.valid = false
                            console.log(uploadEvent)
                            this.progress = Math.round((uploadEvent.loaded / uploadEvent.total * 100))
                            document.getElementById('progress').style.width = this.progress + '%'
                            document.getElementById('progress-text').innerText = 'Aguarde, processando os arquivos ' + this.progress + '%, carregados ' + this.bytesToSize(uploadEvent.loaded) + ' de ' + this.bytesToSize(uploadEvent.total)
                        },
                        headers: {
                            'Authorization': this.$store.state.token,
                            'content-type': 'multipart/form-data'
                        }
                    }).then(function (response) {
                        document.getElementById('progress').style.width = '0%'
                        document.getElementById('progress-text').innerText = ''
                        if (response.data.success === true) {
                            self.success = true
                            self.messages = response.data.messages
                            self.filenames = []
                            self.doUpload = false
                            self.valid = true
                            setTimeout(function () {
                                self.$router.push('/')
                            }, 2000)
                        } else {
                            self.error = true
                            self.messages = response.data.messages
                            self.valid = true
                            self.loading = false
                        }
                    })
                }
            },
            cancelUploads: function () {
                this.filenames = []
                this.doUpload = false
                this.valid = true
                this.success = false
                this.error = false
            }
        }
    }
</script>
